var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"ranking-board"}},[_c('div',{staticClass:"ranking-board-title"},[_vm._v("交易数量 TOP5")]),_c('dv-scroll-ranking-board',{attrs:{"config":_vm.config}}),_c('div',{staticClass:"ranking-board-title"},[_vm._v("交易金额 TOP5")]),_c('dv-scroll-ranking-board',{attrs:{"config":_vm.amount}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }